<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                title="Sitetype kopieren"
                :ok-disabled="!validate"
                :loading="loading"
                @ok="submit"
                ok-text="Kopieren"
                @cancel="close">
            <Input :value="vuexState.selectedType ? vuexState.selectedType.Name : null"
                   label="zu kopierender Sitetype"
                   :disabled="true"></Input>
            <Input v-model="name" label="Bezeichnung"
                   :error-messages="nameErrors"
                   :required="true"
                   @input="$v.name.$touch()"
                   @blur="$v.name.$touch()"></Input>
            <Input v-model="hash" label="Hash"
                   :error-messages="hashErrors"
                   :required="true"
                   @input="$v.hash.$touch()"
                   @blur="$v.hash.$touch()"></Input>
        </Dialog>
        <Snackbar v-model="successSnackbar" color="success">Sitetype erfolgreich kopiert.</Snackbar>
    </div>
</template>

<script>
import Snackbar from "../../../components/Snackbar";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import Utils from "../../../scripts/Utils";
import Input from "../../../components/Inputs/Input";
import Dialog from "../../../components/Dialog";
import ada from "../../../scss/ada_colors.scss";

export default {
    name: "CopySitetypeDialog",
    components: {Dialog, Input, Snackbar},
    props: ['value'],
    mixins: [validationMixin],
    validations: {
        name: {required},
        hash: {required},
    },
    data: () => {
        return {
            name: null,
            hash: null,
            loading: false,
            successSnackbar: false,
            showDeleteDomainDialog: false,
            ada
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        siteDetails() {
            return this.vuexState.siteDetails;
        },
        nameErrors() {
            return Utils.handleError(this, 'name', 'Name ist erforderlich.');
        },
        hashErrors() {
            return Utils.handleError(this, 'hash', 'Hash ist erforderlich.');
        },
        validate() {
            return this.nameErrors.length === 0;
        }
    },
    methods: {
        init() {
            this.name = null;
            this.hash = null;
        },
        async submit() {
            this.$v.$touch();
            if (this.validate) {
                this.loading = true;
                let data;
                try {
                    data = await this.$store.dispatch('display/copySitetype', this.getBody());
                    this.loading = false;
                    if (data.Status) {
                        this.successSnackbar = true;
                        this.close();
                    }
                } catch (e) {
                    this.loading = false;
                }
            }
        },
        getBody() {
            return {
                publisher_id: this.siteDetails.Site.PublisherId,
                site_id: this.siteDetails.Site.SiteId,
                type_id: this.siteDetails.Current.SitetypeId,
                Name: this.name,
                Hash: this.hash
            }
        },
        close() {
            this.init();
            this.$emit('input', false); // set v-model to false -> close dialog
        }
    },
}
</script>

<style lang="scss" scoped>

::v-deep tbody tr {
    cursor: pointer;
}

</style>